import react, { useState, useEffect } from 'react';
import { Box, Hidden, makeStyles } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import classnames from 'classnames';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import MovieCardHome from '../MovieCardSimple/MovieCardHome';
import styles from './styles';
import Backend_API from '../../../../api';
import { useHistory } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // import the styles

const useStyles = makeStyles(styles);
// import 'swiper/swiper-bundle.css';
// const Backend_API = `http://localhost:8080`;

function NextArrow(props) {
  const { currentSlide, slideCount, onClick } = props;
  const classes = useStyles({ currentSlide, slideCount });
  return (
    <div className={classnames(classes.arrow, 'nextArrow')} onClick={onClick}>
      <Box className={classes.arrowIcon}>
        <ArrowForwardIcon style={{ color: '#333', fontSize: '24px' }} />
      </Box>
    </div>
  );
}

function PrevArrow(props) {
  const { currentSlide, onClick } = props;
  const classes = useStyles({ currentSlide });
  return (
    <div className={classnames(classes.arrow, 'prevArrow')} onClick={onClick}>
      <Box className={classes.arrowIcon}>
        <ArrowBackIcon style={{ color: '#333', fontSize: '24px' }} />
      </Box>
    </div>
  );
}

function SingleMovieCarousel({
  carouselClass,
  movies = [],
  showtimes = [],
  cinemas = [],
  title,
  to = null,
  props,
}) {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const classes = useStyles();
const settings = {
  centerMode: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  dotsClass: 'slick-dots',
  pauseOnHover: true,
  adaptiveHeight: false,
};
  const BannerImages = async () => {
    let BASEURL = `${Backend_API}`;
    let url;
    url =
      history.location.pathname === '/private/movies'
        ? `/users/banner/ads?public=false`
        : `/users/banner/ads?public=true`;
    const response = await fetch(BASEURL + url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();
    // console.log('this is banner daata', data);
    setBanner(data);
  };
  useEffect(() => {
    BannerImages();
  }, []);

const handleImageClick = siteLink => {
    if (!siteLink) return;
    const localLink = siteLink
        .replace('https://innovativemultiplex.com/#', '')
        .replace('http://innovativemultiplex.com/#', '');
    if (localLink.startsWith('http')) {
        window.open(localLink, '_blank');
    } else {
        history.push(localLink);
    }
};

  return (
  <div style={{
    width: '100%',
    position: 'relative',
    paddingBottom: '48px',
    marginBottom: '16px',
  }}>
    <Slider {...settings} className={classes.slider}>
      {banner.map(item =>
        item.map((images, idx) => (
          <div key={idx}>
            <MovieCardHome
              image={images.image}
              siteLink={images.siteLink}
              handleImageClick={handleImageClick}
            />
          </div>
        ))
      )}
    </Slider>
  </div>
);
}
export default SingleMovieCarousel;
